/**
 * Route guard — yêu cầu đăng nhập và/hoặc vai trò cụ thể.
 *
 * Chưa đăng nhập: redirect về trang chủ kèm state openLogin và returnTo.
 * Sai vai trò: redirect về trang chủ.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { UI_MESSAGES } from '../../shared/constants/messages';
import { APP_ROUTES } from '../../shared/constants/routes';
import { ADMIN_ROLES, USER_ROLES } from '../../shared/constants/users';

/**
 * Bảo vệ route con theo trạng thái auth.
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {string|null} [props.requiredRole] - Vai trò bắt buộc (admin dùng ADMIN_ROLES)
 */
export const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();
  const allowedRoles = requiredRole === USER_ROLES.admin ? ADMIN_ROLES : [requiredRole];

  if (loading) {
    return <div className="page-loader">{UI_MESSAGES.loadingAccount}</div>;
  }

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;

    return (
      <Navigate
        to={APP_ROUTES.home}
        replace
        state={{
          openLogin: true,
          returnTo,
        }}
      />
    );
  }

  if (requiredRole && !allowedRoles.includes(user?.role)) {
    return <Navigate to={APP_ROUTES.home} replace />;
  }

  return children;
};
